/**
 * Backend API base URL (includes /api suffix).
 *
 * Development: defaults to http://localhost:5000/api
 * Production build: set REACT_APP_API_URL in .env.production before `npm run build`
 */
export function getApiBaseUrl() {
  const configured = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');
  if (configured) {
    return configured.endsWith('/api') ? configured : `${configured}/api`;
  }
  // return 'http://localhost:5000/api';
  return 'https://apingxp.victione.com:8451/api'
}

export function getServerUrl() {
  return getApiBaseUrl().replace(/\/api$/, '');
}
